import { useMemo } from 'react';
import { useAuthStore } from '@/stores/authStore';
import JobsApiClient from '@/lib/api';

export function useApiClient() {
  const apiKey = useAuthStore((state) => state.apiKey);

  const client = useMemo(() => {
    if (!apiKey) {
      return null;
    }

    return new JobsApiClient({
      baseUrl: '',
      apiKey,
    });
  }, [apiKey]);

  return client;
}
